import { provideTranslateHttpLoader } from '@ngx-translate/http-loader'
import { environment } from '@environments/environment'

export const TRANSLATE_LOADER = provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: `.json?v=${environment.version}` })
